/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Mail_Compose_Preview_ForInputs */

const en_mail_compose_preview_for = /** @type {(inputs: Mail_Compose_Preview_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preview for ${i?.name}`)
};

const de_mail_compose_preview_for = /** @type {(inputs: Mail_Compose_Preview_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vorschau für ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Preview for {name}" |
*
* @param {Mail_Compose_Preview_ForInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_preview_for = /** @type {((inputs: Mail_Compose_Preview_ForInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_Preview_ForInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_preview_for(inputs)
	return en_mail_compose_preview_for(inputs)
});